import React from 'react';
import PropTypes from 'prop-types';
import SvgFileIcon from 'ax/components/SvgFileIcon';

class SingleStage extends React.PureComponent {
  static propTypes = {
    stage: PropTypes.object,
    translations: PropTypes.object,
  }

  render() {
    const {
      stage,
      translations,
    } = this.props;

    if (!stage) {
      return null;
    }

    const youAreInText = (translations && translations.you_are_in) || 'YOU ARE IN';

    return (
      <div className="ax-menu-single-stage-container">
        {
          !stage.hidden &&
            <React.Fragment>
              <div className="ax-stage-circle-container">
                <div className="ax-stage-circle">
                  <SvgFileIcon name={stage.name} className={`ax-stage-icon ${stage.name}`} />
                </div>
              </div>
              <div className="ax-single-stage__description">
                <div className="ax-single-stage__you-are-in">{youAreInText.toUpperCase()}</div>
                <div className="ax-single-stage__title">{stage.portal_title || stage.title}</div>
              </div>
            </React.Fragment>
        }
      </div>
    );
  }
}

export default SingleStage;
